<template>
  <section class="contact section" id="contact">
    <div class="info-box">
      <div class="content">
        <h2 class="title lil">Onde Estamos</h2>
        <ul class="info">
          <li><i class="icon phone"></i><a :href="'tel:'+justNumbersTel()"><span>{{api.telefone}}</span></a></li>
          <li><i class="icon e-mail"></i><a :href="('mailto:' + api.e_mail)"><span>{{api.e_mail}}</span></a></li>
          <li><i class="icon location"></i><span>{{api.endereco}}</span></li>
        </ul>
        <a target="_blank" :href="'https://api.whatsapp.com/send?phone='+justNumbers()+'&text=Estou%20mandando%20mensagem%20pelo%20link%20do%20botao%20de%20contato%20do%20site.'" class="cta">Fale Conosco</a>
        <ul class="social">
          <li><a target="blank" href="https://www.google.com/maps/place/Allegretti+Advogados/@-15.8027243,-47.8817845,17z/data=!3m1!4b1!4m5!3m4!1s0x935a3b26d4d6a13f:0xfb107fa4ad8cff44!8m2!3d-15.8027243!4d-47.8795958" class="maps"></a></li>
          <li><a target="blank" href="https://www.waze.com/ul?ll=-15.80272430%2C-47.87959580&navigate=yes" class="waze"></a></li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Contato',
  props: ['api'],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    justNumbersTel() {
      let numb = this.api.telefone;
      let numsStr = numb.replace(/[^0-9]/g,'');
      return parseInt(numsStr);
    },
    justNumbers() {
      let numb = this.api.telefone;
      let numsStr = numb.replace(/[^0-9]/g,'');
      return parseInt(numsStr);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
  #contact
    padding 100px 0
    background url('../assets/contact-bg.jpg') center no-repeat
    background-size cover
    @media (max-width 640px)
      padding 50px 0
    .info-box
      width 650px
      padding 85px
      text-align left
      box-sizing border-box
      box-shadow 0 0 15px rgba(0,0,0, .1)
      background white
      .title
        text-align left
        margin-bottom 20px
      .info
        li
          margin-bottom 5px
          &:last-child
            position relative
            top -5px
            i
              top 7px
          i
            display inline-block
            margin-right 10px
            position relative
            top 3px
            &.phone
              width 24px
              height 24px
              background url('../assets/icon-phone.png') no-repeat center
            &.e-mail
              width 24px
              height 19px
              background url('../assets/icon-mail.png') no-repeat center
            &.location
              width 20px
              height 26px
              margin-right 15px
              background url('../assets/icon-location.png') no-repeat center
      .cta
        font-size 28px
        border-radius 50px
        text-transform uppercase
        border 5px solid black
        padding 16px 40px
        max-width 335px
        box-sizing border-box
        text-align center
        font-weight bold
        margin 30px 0
        display block
        transition .2s all ease
        &:hover
          background black
          color white
      .social
        li
          display inline-block
          margin-right 20px
          &:last-child
            margin-right 0
          a
            display block
            background cyan
            &.maps
              width 57px
              height 57px
              background url('../assets/icon-maps.png') no-repeat center
              background-size cover
            &.waze
              width 47px
              height 47px
              position relative
              top -5px
              background url('../assets/icon-waze.png') no-repeat center
    @media (max-width 670px)
      .info-box
        width 100%
        padding 100px 30px
    @media (max-width 400px)
      .info-box
        .cta
          font-size 18px
</style>



// WEBPACK FOOTER //
// src/components/ContactSection.vue